module.exports = __webpack_public_path__ + "static/media/mobile-clock-wallpaper.9ed4337c.jpg";